module.exports = __webpack_public_path__ + "img/bomb.2794423b.svg";